// extracted by mini-css-extract-plugin
export var content = "_5j-3";
export var list = "_5j-4";
export var settingsContent = "_5j-7";
export var settingsPanel = "_5j-8";
export var state = "_5j-6";
export var triggerBadge = "_5j-2";
export var triggerButton = "_5j-1";
export var triggerShell = "_5j-0";
export var unreadDot = "_5j-5";